import { Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useTranslations } from 'next-intl'

import Center from '~/components/Center'
import Link from '~/components/Link'

export default function NotAuthorized() {
  const t = useTranslations('errors.NotAuthorized')
  return (
    <Center.Middle>
      <Stack spacing={10} alignItems="center">
        <Typography variant="h1">401</Typography>

        <Stack spacing={0} alignItems="center">
          <Typography variant="h4">{t('title')} 🔐</Typography>
          <Typography variant="body2">{t('description')}</Typography>
        </Stack>

        <Button href="/" component={Link} variant="contained" sx={{ px: 5.5 }}>
          {t('backToHome')}
        </Button>
      </Stack>
    </Center.Middle>
  )
}
